var SocialPopularSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$solutionList = $("#socialPopularSolutions");
    this.$noContent = $("#noSocialPopularSolutions");
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/app/portlets/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "companyViews",
      timerange: "lastweek"
    };

    $.post(url, data)
      .done(function(r) {

        var hasItems = r !== undefined && r.companyViews !== undefined && r.companyViews.length > 0;

        if (hasItems) {
          var items = r.companyViews;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            $link.text(items[i].title);
            $link.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + items[i].id);
            var $li = $("<li></li>");
            $li.append($link);
            _self.$solutionList.append($li);
          }
        } else {
          _self.$solutionList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};